module.exports = __webpack_public_path__ + "assets/img/package-baby.70e8a586.svg";